import { defineStore } from 'pinia';
import { type_config, user_info, common_config_list, common_media_type } from '../services/request';
import encrypt from '../utils/crypto-util';

// 导出表单缓存 Store
export { useFormCacheStore } from './formCache';

// 导出路由参数管理 Store
export { useRouteParamsStore } from './routeParams';

export const useNewpageData = defineStore('newpagedata', {
    state: () => ({
        history: '我是历史',
        deteil: {}
    }),
    getters: {
    },
    actions: {
        thisHistory(path: string) {
            this.history = path
        },
        changedeteil(data: any) {
            this.deteil = data
        }
    },
});

// 用户信息数据管理Store
export const useUserInfoStore = defineStore('userInfo', {
    state: () => ({
        // 用户信息数据
        userInfo: null as any,

    }),

    getters: {
        // 获取用户信息
        getUserInfo: (state) => state.userInfo,


    },

    actions: {
        // 获取用户信息
        async fetchUserInfo() {
            try {
                const response = await user_info({});
                console.log(response, '获取个人信息');

                if (response.code === 0) {
                    this.userInfo = response.data;

                    // 加密后存到本地
                    localStorage.setItem('userinfomation', encrypt.aesEncrypty(JSON.stringify(response.data)));
                    console.log(localStorage.getItem('userinfomation'), '加密后存到本地');
                    return this.userInfo;
                } else {
                    throw new Error(response.msg || '获取用户信息失败');
                }
            } catch (error: any) {
                console.error('获取用户信息失败:', error);
                throw error;
            }
        },

        // 更新用户信息
        updateUserInfo(userInfo: any) {
            this.userInfo = userInfo;
        },

        // 重置store状态（退出登录时使用）
        resetStore() {
            this.userInfo = null;
        }
    }
});

// 公共配置列表数据管理Store
export const useConfigListStore = defineStore('configList', {
    state: () => ({
        // 配置列表数据
        configList: null as any,
        // 加载状态
        loading: false,
        // 错误信息
        error: null as string | null,
        // 数据是否已加载
        isLoaded: false,
        // 最后更新时间
        lastUpdated: null as number | null
    }),

    getters: {
        // 获取配置列表
        getConfigList: (state) => state.configList,


        // 传入id 返回配置对象 4 每个用户的媒体数上限 5 每个用户的推广位数上限 6 实人认证地址 7 客服信息
        getConfigById: (state) => (id: number) => {
            if (!state.configList || !Array.isArray(state.configList)) {
                return null;
            }
            return state.configList.find((item: any) => item.id === id);
        },

    },

    actions: {
        // 获取配置列表
        async fetchConfigList() {
            try {
                const response = await common_config_list({});
                console.log(response, '获取配置列表');

                if (response.code === 0) {
                    this.configList = response.data;
                    return this.configList;
                } else {
                    throw new Error(response.msg || '获取配置列表失败');
                }
            } catch (error: any) {
                this.error = error.message || '网络请求失败';
                console.error('获取配置列表失败:', error);
                throw error;
            } finally {
                this.loading = false;
            }
        },

        // 重置store状态
        resetStore() {
            this.configList = null;
        }
    }
});

// 类型配置数据管理Store
export const useTypeConfigStore = defineStore('typeConfig', {
    state: () => ({
        // 存储接口返回的数据
        typeConfigData: null as any,
        // 加载状态
        loading: false,
        // 错误信息
        error: null as string | null,
        // 数据是否已加载
        isLoaded: false,
        // 最后更新时间
        lastUpdated: null as number | null
    }),

    getters: {
        /**
         * 获取类型配置数据
         *1三方平台类型2 学院课程类型3 消息类型4 订单类型
         *5 平台活动类型
         */
        getTypeConfigData: (state) => state.typeConfigData,

        /**
         * 根据id获取特定的类型配置对象
         * @param id 数字类型的id
         * @returns 匹配的配置对象或undefined
         * // 类型配置 el-select 格式处理
         */
        getTypeConfigById: (state) => (id: number) => {
            let elselect = []
            if (!state.typeConfigData || !Array.isArray(state.typeConfigData)) {
                return []; // 返回空数组而不是 undefined
            }
            // 找到id相同的对象
            let newdata = state.typeConfigData.find((item: any) => item.id === id);
            // 
            if (newdata && newdata.typeList) {
                //处理成el-select格式
                elselect = newdata.typeList.map((item: any) => {
                    return {
                        label: item.name,
                        value: item.id
                    }
                })
            } else {
                return [];
            }

            return elselect
        },
        /**
       * 根据id获取特定的类型配置对象
       * @param id 数字类型的id
       * @returns 匹配的配置对象或null
       */
        getTypeConfigByIdList: (state) => (id: number) => {
            if (!state.typeConfigData || !Array.isArray(state.typeConfigData)) {
                return null; // 返回null而不是undefined，保持一致性
            }
            return state.typeConfigData.find((item: any) => item.id === id) || null;
        },

        // 获取加载状态
        isLoading: (state) => state.loading,

        // 获取错误信息
        getError: (state) => state.error
    },

    actions: {
        // 请求类型配置数据
        async fetchTypeConfig(params: any = {}) {
            try {
                const response = await type_config(params);
                console.log(response, '类型配置返回');

                if (response.code == 0) {
                    this.typeConfigData = response.data;
                    this.isLoaded = true;
                    this.lastUpdated = Date.now();
                    return this.typeConfigData;
                } else {
                    throw new Error(response.data?.message || '获取类型配置失败');
                }
            } catch (error: any) {
                this.error = error.message || '网络请求失败';
                console.error('获取类型配置失败:', error);
                throw error;
            } finally {
                this.loading = false;
            }
        },

        // 重置store状态
        resetStore() {
            this.typeConfigData = null;
        }
    }
});

// 媒体类型数据管理Store
export const useMediaTypeStore = defineStore('mediaType', {
    state: () => ({
        // 媒体类型数据
        mediaTypeData: null as any,
        // 平台类型列表
        platformTypes: [] as any[],
        // 流量类型列表  
        trafficTypes: [] as any[],
        // 加载状态
        loading: false,
        // 错误信息
        error: null as string | null,
        // 数据是否已加载
        isLoaded: false,
        // 上次更新时间
        lastUpdated: null as number | null,
        // 数据有效期（5分钟）
        cacheExpireTime: 5 * 60 * 1000,
        // 媒体类型数组
        processedData: null as any
    }),

    getters: {
        // 获取媒体类型数据
        getMediaTypeData: (state) => state.mediaTypeData,

        // 获取媒体类型列表
        getPlatformTypes: (state) => {
            console.log(state.processedData, '平台类型列表');
            if (!state.processedData) {
                return [];
            }
            const result = state.processedData
            let newdata = result.platformTypes;
            return newdata.map((item: any) => {
                return {
                    label: item.name,
                    value: item.id,
                    ddesc: item.desc
                }
            });
            return newdata
        },


        // 获取流量类型列表 变成符合el-select格式
        getTrafficTypes: (state) => {
            if (!state.processedData) {
                return [];
            }
            const result = state.processedData
            let newdata = result.trafficTypes;
            return newdata.map((item: any) => {
                return {
                    label: item.name,
                    value: item.id,
                    ddesc: item.desc
                }
            });
            return newdata
        },


        //获取媒体类型数组 和流量类型数组
        getMediaTypeArray: (state) => {
            if (!state.mediaTypeData || !Array.isArray(state.mediaTypeData)) {
                return {
                    platformTypes: [],
                    trafficTypes: []
                };
            }

            // 提取所有第一层的平台类型对象（移除 ttList 字段）
            const platformTypes = state.mediaTypeData.map(item => ({
                id: item.id,
                name: item.name,
                desc: item.desc,
                status: item.status,
                createTime: item.createTime,
                createUid: item.createUid,
                orderNum: item.orderNum,
                pid: item.pid,
                version: item.version
            }));

            // 提取所有 ttList 中的流量类型对象，并添加 platformId 标识
            const trafficTypes: any[] = [];
            state.mediaTypeData.forEach(platform => {
                if (platform.ttList && Array.isArray(platform.ttList)) {
                    platform.ttList.forEach(traffic => {
                        trafficTypes.push({
                            ...traffic,
                            platformId: platform.id,  // 添加所属平台ID
                            platformName: platform.name  // 添加所属平台名称
                        });
                    });
                }
            });

            return {
                platformTypes,
                trafficTypes
            };
        },



        // 获取加载状态
        isLoading: (state) => state.loading,

        // 获取错误信息
        getError: (state) => state.error
    },

    actions: {
        // 获取媒体类型数据
        async fetchMediaType() {
            try {
                const response = await common_media_type({});
                console.log('媒体类型数据:', response);

                if (response.code === 0) {
                    // 存储完整的原始数据
                    this.mediaTypeData = response.data;

                    // 通过 getter 自动处理数据结构
                    this.processedData = this.getMediaTypeArray;
                    console.log('处理后的数据结构:', this.processedData);

                    return response.data;
                } else {
                    throw new Error(response.message || '获取媒体类型失败');
                }
            } catch (error: any) {
                this.error = error.message || '网络请求失败';
                console.error('获取媒体类型失败:', error);
                throw error;
            } finally {
                this.loading = false;
            }
        },

        // 重置状态
        resetStore() {
            this.mediaTypeData = null;
        }
    }
});
